import React from 'react';
import { Grid } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import DurationBar from './DurationBarComponent';
import { PROP_TYPES } from '../constants';

export default function StopItem({ stopDetails, color, onStopClicked, stopIndex, maxDuration }) {
  return (
    <>
      <Grid.Row
        className="stop-item-row"
        onClick={() => {
          onStopClicked(stopDetails);
        }}
      >
        <Grid.Column
          style={{ width: '20px !important', top: '12px', left: '-10px', position: 'absolute' }}
          className="no-of-tasks-div"
        >
          <div className="no-of-tasks-circle" style={{ background: color }}>
            <span style={{ verticalAlign: 'middle' }}>{stopIndex + 1}</span>
          </div>
        </Grid.Column>
        <Grid.Column width={stopDetails.numberOfTasks ? 14 : 16}>
          <Grid.Row className="user-timings-div">{stopDetails.userTimings}</Grid.Row>
          <Grid.Row className="stop-name-div" title={stopDetails.stopName}>
            {stopDetails.stopName}
          </Grid.Row>
          <Grid.Row className="taskcount-duration-div">
            {stopDetails.numberOfTasks ? `${stopDetails.numberOfTasks} Task(s) |` : ''}&nbsp;
            {stopDetails.durationInMinutes} mins
          </Grid.Row>
          <DurationBar color={color} maxDuration={maxDuration} stopDuration={stopDetails.durationInMinutes} />
        </Grid.Column>
      </Grid.Row>
    </>
  );
}

StopItem.propTypes = {
  stopDetails: PROP_TYPES.ROUTE_DATA_STOP.isRequired,
  onStopClicked: PropTypes.func.isRequired,
  color: PropTypes.string.isRequired,
  stopIndex: PropTypes.number.isRequired,
  maxDuration: PropTypes.number.isRequired,
};
